<template>
  <div class="mt-5 mr-5">
    <CRow style="background-color: transparent !important;height:190px">
      <transition appear name="slide" type="animation">
        <CCard class="fav-card">
          <CCardHeader class="pb-0">
            <!-- display meatball icon -->
            <CRow>
              <CCol>
                <div
                  v-if="this.$store.getters['auth/userStatus']"
                  @click="showMenu"
                  class="straigtMenu"
                >
                  <i class="fa fa-ellipsis-h fa-2x" color="#B3B3B3" />
                </div>
              </CCol>
            </CRow>

            <!-- display title -->
            <CRow>
              <CCol class="subtitle">
                <p style="height:90px;overflow:hidden">{{data.title[0].val}}</p>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <!-- for click area -->
            <div @click="sendCourseData(data)">
              <!-- display fullname -->
              <CRow>
                <CCol>
                  <p class="subtitle2">{{data.name[0].val}}</p>
                </CCol>
              </CRow>

              <!-- display  study hrs-->
              <CRow>
                <CCol class="description">Study hours</CCol>
                <CCol class="text-right description">{{data.studyHour}}</CCol>
              </CRow>

              <!-- display Category -->
              <CRow>
                <CCol class="description">Category</CCol>
                <CCol
                  class="text-right description h-auto"
                  style="overflow: hidden;text-overflow: ellipsis;width:120px;"
                >
                  <p>{{categorysName}}</p>
                </CCol>
              </CRow>
            </div>
          </CCardBody>
        </CCard>
      </transition>

      <!-- display menu -->
      <transition name="slide" type="animation">
        <div v-show="showingMenu" class="ml-3" style="margin-top: -45px;">
          <div v-for="(item, index) in menu" :key="index">
            <span
              v-c-tooltip.click.hover="{
                      content: item.name,
                      placement: 'right',
                      }"
              @click="clickIcon(item.name)"
              style="border-radius: 50%; padding-left: 0.3rem;padding-right: 0.3rem;padding-top: 15rem.; padding-bottom: 0.15rem;background: white; box-shadow: 1px 1px 2px black;"
            >
              <i
                :class="item.icon"
                :color="item.color"
                style="height: 16px; width: 16px; margin-top: 0.95rem;"
              />
            </span>
          </div>
        </div>
      </transition>
    </CRow>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isVisible: false,
      showingMenu: false,
      value: 60,
      max: 100,
      categorysName: "",
      menu: [
        // {
        //   name: "star",
        //   status: false,
        //   color: "gray",
        //   icon: "fas fa-star",
        // },
        // {
        //   name: "share",
        //   status: false,
        //   color: "#6767FF",
        //   icon: "fas fa-share-square",
        // },
      ],
    };
  },
  props: {
    data: Object,
  },

  mounted() {
    this.userProfile = this.$store.getters["userProfileGetter"];
    this.checkLanguage();
  },
  watch: {},

  methods: {
    sendCourseData(data) {
      let courseCodeData = {
        courseCode: data.code,
        objectId: data._id,
      };
      this.$store.commit("dataCourse", courseCodeData);
      this.$router.push({
        name: "Overview",
        params: {
          courseCode: this.data.code,
          courseID: this.data._id,
        },
      });
    },
    showMenu() {
      this.showingMenu = !this.showingMenu;
    },
    clickIcon(icon) {
      // if (icon == "star") {
      //   let payload = {
      //     course_id: this.data._id,
      //     user_id: this.userProfile._id,
      //   };
      //   this.$store.dispatch("addFavoutiteCourse", payload);
      // }
    },
    onPressUnenrollModal() {
      this.isVisible = true;
    },
    checkLanguage() {
      if (this.data.categorys) {
        for (let index = 0; index < this.data.categorys.length; index++) {
          const element = this.data.categorys[index].category.title;
          for (let index2 = 0; index2 < element.length; index2++) {
            const element2 = element[index2];
            if (element2.key == "en") {
              this.categorysName = element2.val;
              // Loop categorys
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.fav-card {
  width: 220px;
  height: 235px;
  margin-left: 15px;
  top: -48px;
  cursor: pointer;
}
.fav-card:hover {
  background: #6d6d6d 0% 0% no-repeat padding-box;
}
.card {
  box-shadow: 5px 5px 10px #0000004d;
  border: white;
  border-radius: 40px;
  background: #4d4d4d 0% 0% no-repeat padding-box;
  transition: transform 0.2s;
  width: 220px;
  height: 220px;
}

.card-header {
  background-color: transparent;
  border: none;
  padding-top: 0px;
}

.card-body {
  padding: 0rem 1.25rem;
}

.straigtMenu {
  z-index: 999;
  margin-right: -0.3rem;
  position: absolute;
  background: white;
  height: 40px;
  width: 57px;
  text-align: end;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 40px;
  cursor: pointer;
}

.straigtMenu:hover {
  /* -webkit-filter: brightness(70%); */
  filter: brightness(70%);
}

.progressBar {
  width: 9rem;
  height: 43px;
  border-radius: 50px;
  box-shadow: none;
  padding: 5px;
  overflow: visible;
}

.overviewIcon:hover {
  /* -webkit-filter: brightness(70%); */
  filter: brightness(0.4);
}

.description {
  font-size: 0.875rem;
  color: white;
}

/* -- ---------------------------------------------------------- CSS MODAL -------------------------------------------------- -- */

.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  margin-right: 12px;
  cursor: pointer;
  margin-bottom: 0.1em;
}

.button {
  outline: none;
  border: none;
  width: 12rem;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 40px;
  font-size: 16px;
  margin: 10px;
}

.drobdown_modal {
  width: 90%;
  border: 0px;
  border-bottom: 1px solid #cccccc;
  margin-left: 20px;
}

.modal-text p {
  font-weight: 300;
  font-size: 16px;
  color: black;
  margin-bottom: 0px;
}

.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: black;
  text-align: center;
}

.modal-content p {
  font-size: 24px;
  margin-top: 0.6em;
}

.tab {
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

.widthLoginModal {
  width: 420px;
  position: inherit;
}

.slide-enter {
  opacity: 0;
}

.slide-enter-active {
  transition: opacity 0.4s;
  animation: slide-in 0.4s ease-out forwards;
}

/* .slide-leave {
} */

.slide-leave-active {
  transition: opacity 0.4s;
  opacity: 0;
  animation: slide-out 0.4s ease-in forwards;
}
.subtitle {
  text-align: left;
  font: Bold 70px/92px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  /* overflow: hidden;
  text-overflow: ellipsis; */
  height: 90px;
}
.subtitle2 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  font: Bold 16px/21px Roboto;
  color: white;
  height: 24px;
}

@keyframes slide-in {
  from {
    transform: translateX(-1.5rem);
  }
  to {
    transform: translateX(0rem);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0rem);
  }
  to {
    transform: translateX(-1.5rem);
  }
}
</style>
